import { Injectable, Injector } from "@angular/core";
import { BaseApi } from "@services/api/base.api";
import { Observable } from "rxjs";

@Injectable()
export class RankingApi extends BaseApi {
	constructor( injector: Injector ) { super(injector); }

	public getFullRanking(): Observable<any> {
		return this.get(this.url("/ranking/full")).pipe(this.defaultMap);
	}

}
